var map = {
	"./reset-password-appedology.vue": [
		71079,
		1079
	],
	"./reset-password-default.vue": [
		22434,
		2434
	],
	"./reset-password-proglobal.vue": [
		46651,
		6651
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 25927;
module.exports = webpackAsyncContext;